module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Rhino_C.0e2dcbe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Handgun/Item_Weapon_Rhino_C.png
// module id = ./src/assets/item/Weapon/Handgun/Item_Weapon_Rhino_C.png
// module chunks = 0